import React from 'react';
import { IfmsRoute }from '../../../config/types';

export const OtherShipmentView = React.lazy(() => import("../otherShipment/OtherShipmentView"));
const OtherShipmentBillingsView = React.lazy(() => import('../otherShipment/OtherShipmentBillingsView'));
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView')); //
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView')); //
const DeliveryOrderView = React.lazy(() => import('../../reports/DeliveryOrderView'));
const OtQuotationView = React.lazy(() => import('../quotation/OtQuotationView'));
const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
const CargoManifestStatusView = React.lazy(() => import('../../reports/CargoManifestStatusView'));

const routes: Array<IfmsRoute> = [
  // {path: '/otherShipment/home', component: Home},
  { path: '/otherShipment/otherShipment/:mode/:id?/:tabIndex?/:createEntity?', component: OtherShipmentView },
  { path: '/otherShipment/viewBillings/:id?', component: OtherShipmentBillingsView },
  { path: '/otherShipment/quotation/:mode/:id?', component: OtQuotationView },

  //Moremunu
  { path: '/otherShipment/straightBl', component: StraightBlView },
  { path: '/otherShipment/pickupDelivery', component: PickupDeliveryView },
  { path: '/otherShipment/shortDeliveryOrder', component: DeliveryOrderView },
  { path: '/otherShipment/folderLabel', component: FolderLabelView },
  { path: '/otherShipment/cargoManifestStatus', component: CargoManifestStatusView },
];

export default routes;
